import { formatDate } from '@angular/common';

import { BuildInfo } from './models/build-info.model';
import { VersionDisplay } from './models/version-display.model';

const productName = 'FLEX BackOffice';
const separator = ' · ';
const shortCommitLength = 7;

// Only production builds carry a release version, so its presence selects the production layout.
export function buildVersionDisplay(buildInfo: BuildInfo): VersionDisplay {
  const isReleaseBuild = buildInfo.releaseVersion !== '';
  const identifier = isReleaseBuild ? buildInfo.releaseVersion : buildInfo.commitSha.slice(0, shortCommitLength);
  const title = identifier ? `${productName} ${identifier}` : productName;
  const environmentName = !isReleaseBuild && buildInfo.environmentName ? buildInfo.environmentName : null;
  const buildDate = formatBuildDate(buildInfo.buildTimestamp);
  const environmentLabel = environmentName
    ? $localize`:@@sidenav.versionDisplay.environmentLabel:${environmentName}:environmentName: environment`
    : null;

  return {
    title,
    environmentName,
    buildDate,
    summary: joinParts([title, environmentName, buildDate]),
    ariaLabel: joinParts([title, environmentLabel, buildDate])
  };
}

// Formatted in the viewer's local time zone, always in en-US.
function formatBuildDate(buildTimestamp: string): string | null {
  const date = new Date(buildTimestamp);
  return buildTimestamp && !Number.isNaN(date.getTime()) ? formatDate(date, 'MMM d, y', 'en-US') : null;
}

function joinParts(parts: (string | null)[]): string {
  return parts.filter((part): part is string => !!part).join(separator);
}
